import { createBrowserHistory, createMemoryHistory } from 'history';

// Vitest runs in a Node environment by default, where `document` is undefined.
// Fall back to an in-memory history for tests/non-browser contexts.
const history = typeof document !== 'undefined' ? createBrowserHistory() : createMemoryHistory();

export default history;
